// extracted by mini-css-extract-plugin
module.exports = {"w1rm9xeo":"w1rm9xeo","c66lvf0":"c66lvf0"};